export default {
  solicitantes: 'Solicitantes',
  entidades: 'Jach\'a utanaka',
  cuenta: 'Cuentaxa',
  configuracion: 'Configuraciones',
  usuarios: 'Atamiri jaqi',
  tramites: 'Trámites',
  modulos: 'Módulos y permisos',
  roles: 'Roles',
  parametros: 'Preferencias',
  documentos: 'Documentos',
  logs: 'Logs del sistema',
  config: 'Configuraciones',
  pagos: 'Pagos',
  tramitesDoc: 'Trámites'
};



// WEBPACK FOOTER //
// ./src/common/lang/ay/menu.js